import './public-path'

import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import './permissions'
import './permissions/version'
import './http/config'

import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'

// markdown
// 预览组件以及样式
import VMdPreview from '@kangc/v-md-editor/lib/preview'
import '@kangc/v-md-editor/lib/style/preview.css'
// VuePress主题以及样式（这里也可以选择github主题）
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
// Prism
import Prism from 'prismjs'
// 代码高亮
import 'prismjs/components/prism-json'
//支持复制
import VueMarkdownEditor from '@kangc/v-md-editor'
import createCopyCodePlugin from '@kangc/v-md-editor/lib/plugins/copy-code/index'
import '@kangc/v-md-editor/lib/plugins/copy-code/copy-code.css'
// 选择使用主题
VMdPreview.use(vuepressTheme, {
  Prism,
})
// markdown支持代码快速复制
VMdPreview.use(createCopyCodePlugin())
// markdown

import {
  Affix,
  ConfigProvider,
  InputNumber,
  Table,
  Button,
  Row,
  Col,
  Checkbox,
  Tabs,
  Pagination,
  Input,
  Rate,
  Popover,
  Dropdown,
  Menu,
  Carousel,
  Empty,
  Upload,
  Spin,
  Progress,
  Modal,
  Tooltip,
  Tag,
  Radio,
  Select,
  TreeSelect,
  Divider,
  Message,
  Form,
  Switch,
} from 'ant-design-vue'

import { createFromIconfontCN } from '@ant-design/icons-vue'
const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3331830_b103plmb2m.js',
})

Message.config({
  maxCount: 1,
})
import tools from '@/utils/utils'

// app.mount('#app')
// createApp(App).use(store).use(router).mount('#app')

let instance = null

async function render(props = {}) {
  const { container, routerBase } = props
  console.log('props', props)

  instance = createApp(App)

  instance.component('IconFont', IconFont)
  instance.config.globalProperties.$tools = tools
  instance.use(store)
  instance.use(router)
  instance.use(PerfectScrollbar)
  instance.use(Affix)
  instance.use(ConfigProvider)
  instance.use(InputNumber)
  instance.use(Table)
  instance.use(Button)
  instance.use(Row)
  instance.use(Col)
  instance.use(Checkbox)
  instance.use(Tabs)
  instance.use(Pagination)
  instance.use(Input)
  instance.use(Rate)
  instance.use(Popover)
  instance.use(Dropdown)
  instance.use(Menu)
  instance.use(Carousel)
  instance.use(Empty)
  instance.use(Upload)
  instance.use(Spin)
  instance.use(Progress)
  instance.use(Modal)
  instance.use(Tooltip)
  instance.use(Tag)
  instance.use(Radio)
  instance.use(Select)
  instance.use(TreeSelect)
  instance.use(Divider)
  instance.use(Form)
  instance.use(Switch)

  // 引入v-md-editor预览组件
  instance.use(VMdPreview)

  instance.mount(container ? container.querySelector('#app') : '#app')

  // eslint-disable-next-line no-underscore-dangle
  if (window.__POWERED_BY_QIANKUN__) {
  }
}

// eslint-disable-next-line no-underscore-dangle
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

export async function bootstrap() {
  console.log('[vue] vue app bootstraped')
}

export async function mount(props) {
  // 标记当前启动形式为微服务启动
  // store.commit("app/microChange", true);
  await render(props)
}

export async function unmount() {
  instance.unmount()
}
